import { TextureData, TrickData } from "../../../types/types";
import { ISize } from "../../../controls/scrollpane/ISize";
import { RectSize } from "../../../utils/RectSize";
import { SettingsItem } from "../options/SettingsItem";
import { AppSettings } from "../../managers/AppSettings";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { CardsManager } from "../../managers/CardsManager";
import { ScrollableContentScreenBase } from "../ScrollableContentScreenBase";
import { LayoutDataManager } from "../../managers/LayoutDataManager";


export class TricksListItem
    extends SettingsItem
    implements ISize {
    public grWinnerOutline: Phaser.GameObjects.Graphics;
    public imgWinningTick: Phaser.GameObjects.Image;

    protected winnerOutlineThickness: number = 10;
    protected imgCards: Phaser.GameObjects.Image[];
    protected bgTextureData: TextureData;

    // delimiter line
    public imgDelimiterLine: Phaser.GameObjects.Image;
    protected hasDelimiterLine: boolean;
    protected delimiterLineAlpha: number;


    public Init(
        bgTextureData: TextureData = undefined,
        delimiterLineAlpha: number,
    ): void {
        this.bgTextureData = bgTextureData;
        this.delimiterLineAlpha = delimiterLineAlpha;

        this.borderPadding.horizontal = 30;
        this.size = new RectSize();
        this.imgCards = [];
    }

    public Build(): void {
        this.bg = this.scene.make.image({ key: this.bgTextureData.texture, frame: this.bgTextureData.frame });
        this.bg.setOrigin(0);
        this.add(this.bg);

        this.grWinnerOutline = this.scene.make.graphics({});
        this.add(this.grWinnerOutline);

        // NOTE: set dummy image
        const tmpCardFrame: string = CardsManager.GetCardFrontFrameName(0, 0);
        for (let i = 0; i < 4; i++) {
            const imgCard = this.scene.make.image({ key: LoaderFileKeys.cardsDeck, frame: tmpCardFrame });
            imgCard.scale = 0.7;
            this.imgCards.push(imgCard);
            this.add(imgCard);
        }

        // draw winner outline once
        const tmpCard: Phaser.GameObjects.Image = this.imgCards[0];
        this.grWinnerOutline.clear();
        this.grWinnerOutline.fillStyle(AppSettings.colors.yellow, 1);
        this.grWinnerOutline.fillRoundedRect(0, 0, tmpCard.displayWidth + 2 * this.winnerOutlineThickness, tmpCard.displayHeight + 2 * this.winnerOutlineThickness, 15);

        this.imgWinningTick = this.scene.make.image({ key: LoaderFileKeys.ui, frame: "results-tricks-tick.png" });
        this.add(this.imgWinningTick);

        this.imgDelimiterLine = this.scene.make.image({ key: LoaderFileKeys.ui, frame: "rect-2x2-white.png" });
        this.imgDelimiterLine.setOrigin(0, 0.5);
        this.imgDelimiterLine.alpha = this.delimiterLineAlpha;
        this.add(this.imgDelimiterLine);
    }

    public SetData(
        trickData: TrickData,
        hasDelimiterLine: boolean,
    ): void {
        this.hasDelimiterLine = hasDelimiterLine;
        this.imgDelimiterLine.visible = hasDelimiterLine;

        for (let i: number = 0; i < this.imgCards.length; i++) {
            const cardImg = this.imgCards[i];
            const cardData = trickData.cards[i];
            const cardFrame = CardsManager.GetCardFrontFrameName(cardData.suit, cardData.rank);
            cardImg.setTexture(LoaderFileKeys.cardsDeck, cardFrame);
        }

        // Position outline and tick over winning card.
        // NOTE: OnResize NOT ran yet, calc pos manually 
        const contentWidth = LayoutDataManager.GetSharedData().general.scrollableContent.size.innerScale;
        const tmpCard = this.imgCards[0];
        const centerY = (tmpCard.displayHeight + 2 * this.borderPadding.vertical) / 2;
        const elementSpace = (contentWidth - 2 * this.borderPadding.horizontal) / 4;
        const halfElementSpace = elementSpace / 2;

        // position winnerIndex outline
        this.grWinnerOutline.setPosition(this.borderPadding.horizontal + halfElementSpace + trickData.winnerIndex * elementSpace - tmpCard.displayWidth / 2 - this.winnerOutlineThickness, this.borderPadding.vertical - this.winnerOutlineThickness);

        // position winnerIndex tick
        this.imgWinningTick.setPosition(this.borderPadding.horizontal + halfElementSpace + trickData.winnerIndex * elementSpace, centerY);
    }

    /**
     * NOTE: In case of this container, the width is always 1000px. 
     *       Rather, when scaling, parent is scaled.
     * @param width 
     * @returns 
     */
    public override SetWidthGetHeight(width: number): number {
        return this.imgCards[0].displayHeight + 2 * this.borderPadding.vertical;
    }

    public override OnResize(): void {
        // console.log("DealsListItem::OnResize");

        // const centerX = this.size.width/2;
        const centerY = this.size.height / 2;
        // horizontal space for element
        const elementSpace = (this.size.width - 2 * this.borderPadding.horizontal) / 4;
        const halfElementSpace = elementSpace / 2;

        this.bg.setDisplaySize(this.size.width, this.size.height);

        // delimiter (if item has it -- last item in list does not have it)
        if (this.hasDelimiterLine) {
            // origin 0,1 (bot left)
            this.imgDelimiterLine.y = this.size.height;
            this.imgDelimiterLine.displayWidth = this.size.width;
        }

        for (let i = 0; i < this.imgCards.length; i++) {
            const cardImg = this.imgCards[i];
            cardImg.setPosition(this.borderPadding.horizontal + halfElementSpace + i * elementSpace, centerY);
        }
    }
}